(() => {
  const name = 'favorites';

  App.common = App.common || {};

  App.common[name] = (() => {
    const config = {
      animationClass: 'flip-favicon',
    };
    let favoritesList = null;
    let prevFavAmount = null;
    let currentAmount = 0;

    const cartAndFavoritesSelector = '[data-cart-and-favorites]';
    const favoritesButtonSelector = '[data-favorites-button]';
    const favoritesCountSelector = '[data-favorites-count]';

    const getArrayFavoritesId = () => (favoritesList || []).map((item) => item.id);

    /**
     * Creates and updates widget by request
     * @private
     * @returns {*} request
     */
    const updateWidget = () => (
      $.ajax({
        url: `/favorites/showAll?${Date.now()}`,
        contentType: 'application/json',
        type: 'GET',
        cache: false,
        success: (data) => {
          favoritesList = data === '' ? [] : JSON.parse(data);
          currentAmount = favoritesList.length;

          const $topMenu = $(cartAndFavoritesSelector);
          const $favoritesButton = $(favoritesButtonSelector);
          const $favoritesCount = $(favoritesCountSelector);

          if (currentAmount > 0) {
            $topMenu.attr('data-has-favorites', '');
            $favoritesButton.addClass('active');
            $favoritesCount.html(currentAmount);

            // Only show heartbeat animation if amount has increased
            if (prevFavAmount !== null && prevFavAmount < currentAmount) {
              $favoritesButton
                .addClass(config.animationClass)
                .one(App.global.animationEndEvent, () => {
                  $favoritesButton.removeClass(config.animationClass);
                });
            }
          } else {
            $favoritesButton.removeClass('active');
            $favoritesCount.html('');

            // Only run shake animation when items are removed
            if ($topMenu.is('[data-has-favorites]')) {
              $favoritesButton
                .addClass('animation--shake')
                .one(App.global.animationEndEvent, () => {
                  $favoritesButton.removeClass('animation--shake');
                  $topMenu.removeAttr('data-has-favorites');
                });
            }
          }

          prevFavAmount = currentAmount;
        },
      }));

    /**
     * sends requests
     * @param {string} action - type of request
     * @param {jQuery} $button - favorite button jQuery element
     * @param {Number} prd - product id
     * @param {object} callbacks - callbacks after ajax complete
     * @param {boolean} dontCallCommon - will not call common callbacks after complete
     */
    const ajax = (action, $button, prd, callbacks = {}, dontCallCommon = false) => {
      // Common callbacks for add (update widget on success, log error on error)
      const commonCallbacks = {
        success: (jqXHR) => {
          if (jqXHR.responseJSON) {
            updateWidget();
          }
        },
        error: () => {
          App.sendErrorToRaygun('error while processing ajax request to remove fav');
        },
      };

      /**
       * Makes the corresponding callback from the array passed as 'callbacks' argument (if any)
       * and common callbacks unless prohibited (dontCallCommon)
       * @param {object} jqXHR - xhr wrapped by jq
       * @param {string} status - status of request
       */
      const complete = (jqXHR, status) => {
        if (typeof callbacks[status] === 'function') {
          callbacks[status](jqXHR);
        }
        if (!dontCallCommon && typeof commonCallbacks[status] === 'function') {
          commonCallbacks[status](jqXHR);
        }
        App.eventBus.trigger(`favorites:${action}`, { $button, productId: prd, response: jqXHR });
      };

      if (prd) {
        $.ajax({
          url: `/favorites/${action}/${prd}`,
          cache: false,
          dataType: 'JSON',
          type: action === 'remove' ? 'POST' : 'GET',
          complete,
        });
      } else {
        App.sendErrorToRaygun(`favorites: unable to ${action} product (${prd})`);
      }
    };

    const toggleFavorite = (e) => {
      e.preventDefault();
      e.stopPropagation();
      const $favButton = $(e.currentTarget);
      const productId = parseInt($favButton.attr('data-id'), 10);
      const action = $favButton.hasClass('is-fav') ? 'remove' : 'add';
      ajax(action, $favButton, productId);
      if (action === 'add') {
        TrackApp.trackInteraction('favorites', `favorites add ${$favButton.data('type')}`, productId);
      }
    };

    const markAsFavorites = (list, $container) => {
      const currentList = list || getArrayFavoritesId();
      const $favButtons = $('.js-add-to-fav-btn, [data-favorite-button]', $container);
      for (let i = 0; i < currentList.length; i += 1) {
        const itemId = currentList[i];
        $favButtons.filter(`[data-id="${itemId}"]`)
          .removeClass('not-fav')
          .addClass('is-fav');
      }
    };

    const mergeFavourites = () => {
      $.ajax({
        url: '/favorites/merge',
        type: 'GET',
        success: (result) => {
          App.global.setCookie('showFavouritesConfirmPopup', false, '/');
          updateWidget();
          markAsFavorites(JSON.parse(result));
        },
        error: (error) => {
          App.sendErrorToRaygun(error);
        },
      });
    };

    const createFavouritesConfirmPopup = () => {
      const showFavouritesConfirmPopup = JSON.parse(App.global.getCookie('showFavouritesConfirmPopup'));

      if (!showFavouritesConfirmPopup) {
        return;
      }

      window.dataLayer = window.dataLayer || [];

      let eventData = {};
      const eventCommonData = {
        eventCategory: 'favorites',
        eventAction: 'popup - merge favorites',
      };

      const collectEventData = (commonData, extendedData) => $.extend({}, commonData, extendedData);

      App.ui.popup(texts('mergeFavouritesConfirmation@popup'), {
        className: 'dialog-window',
        confirm: {
          ok: {
            text: texts('mergeFavouritesOk@popup'),
            callback: () => {
              eventData = collectEventData(eventCommonData, {
                event: 'gaEvent',
                eventLabel: 'selected ok',
              });
              window.dataLayer.push(eventData);
              mergeFavourites();
            },
          },
          cancel: {
            text: texts('mergeFavouritesCancel@popup'),
            callback: () => {
              eventData = collectEventData(eventCommonData, {
                event: 'gaEvent',
                eventLabel: 'selected cancel',
              });
              window.dataLayer.push(eventData);
              App.global.setCookie('showFavouritesConfirmPopup', false, '/');
            },
          },
        },
      });
      eventData = collectEventData(eventCommonData, {
        event: 'gaEventNonInteraction',
        eventLabel: 'popup shown',
      });
      window.dataLayer.push(eventData);
    };

    const setEventListeners = () => {
      App.eventBus.on('favorites:add favorites:remove', (event, { $button, productId }) => {
        const action = event.type === 'favorites:remove' ? 'removeClass' : 'addClass';
        const $productBox = $button.closest(App.settings.productBox ? '[data-product-box]' : '[data-legacy-product-box]');
        // ProductBoxes can be in the Related Products area on Product Page - so they go first.
        if ($productBox.length) {
          $productBox.find('[data-favorite-button]')[action]('is-fav');
        } else if (App.currentPage === 'productPage') {
          // Can be multiple favorite buttons on product page / extra / - with sticky cta on mobile.
          const $buttonsPP = $('.js-add-to-fav-btn')
            .filter((index, btn) => App.global.filterDomElementsByProductId(index, btn, productId));
          $buttonsPP[action]('is-fav');
        }
      });
    };

    /**
     * init
     * @public
     */
    const init = () => {
      updateWidget();
      setEventListeners();
      if (window.userAuthenticated) {
        createFavouritesConfirmPopup();
      }
    };

    return {
      init,
      toggleFavorite,
      markAsFavorites,
    };
  })();
})();
